module.exports = __webpack_public_path__ + "img/xonsaroy_sariq.765fcfd9.png";